import {
  Callout,
  Card,
  H1,
  H3,
  HTMLTable,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import CountUp from "react-countup";

import i18n from "../../../../i18n";
import { authenticatedGetFetch } from "../../../../utils/AuthenticatedFetch";

export default function Matchings(props) {
  const [perfs, setPerfs] = useState();

  useEffect(() => {
    authenticatedGetFetch(
      "/ow/dc/perf/matchings?" +
        new URLSearchParams({
          srv: props.srv,
          ...(props.from && { from: props.from }),
          ...(props.to && { to: props.to }),
        }),
      (perf) => setPerfs(perf)
    );
  }, [props.srv, props.from, props.to]);

  return (
    <Callout icon="mobile-video" title={<Trans>matchings</Trans>}>
      {perfs ? (
        <div>
          <div className="flexbox-center">
            <div>
              <p>
                <Tag icon="help" large="true">
                  {perfs.matchings_count}
                </Tag>{" "}
                <Trans>matches tries</Trans>
              </p>
              <p>
                <Tag icon="known-vehicle" large="true" intent="success">
                  {perfs.matchings_OK_count}
                </Tag>{" "}
                <Trans>matches found</Trans>
              </p>
              <p>
                <Tag icon="unknown-vehicle" large="true" intent="danger">
                  {perfs.matchings_count - perfs.matchings_OK_count}
                </Tag>{" "}
                <Trans>matches failed</Trans>
              </p>
            </div>

            {perfs.matchings_count > 0 && (
              <div>
                <Card>
                  <H3>
                    <Trans>global system performance</Trans>
                  </H3>
                  <br />
                  <H1>
                    <CountUp
                      end={
                        (perfs.matchings_OK_count / perfs.matchings_count) * 100
                      }
                      decimals={2}
                      separator=" "
                      decimal=","
                      suffix="%"
                    />
                  </H1>
                </Card>
              </div>
            )}
          </div>
          <div className="flexbox-center">
            <HTMLTable compact={true} striped={true}>
              <thead>
                <tr>
                  <th>
                    <Trans>matching method</Trans>
                  </th>
                  <th>
                    <Trans>matching number</Trans>
                  </th>
                </tr>
              </thead>
              <tbody>
                {perfs.matching_methods.map((m) => (
                  <tr key={"mm" + m.method}>
                    <td>
                      <Tag
                        intent={
                          m.method === 0
                            ? "success"
                            : m.method > 0
                            ? "warning"
                            : "danger"
                        }
                      >
                        {m.method != null
                          ? i18n.t("tolerance_level_" + m.method)
                          : i18n.t("no result")}
                      </Tag>
                    </td>
                    <td>{m.count}</td>
                  </tr>
                ))}
              </tbody>
            </HTMLTable>
          </div>
          {/* <Callout>TODO: performance par période (/jour ou /heure)</Callout> */}
        </div>
      ) : (
        <Spinner />
      )}
    </Callout>
  );
}
